// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcj_a bhp_wl","LoadingPlaceholder":"bcj_b bhp_h","loading-placeholder":"bcj_c"};